var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"ctk-item-tracking-dot tw-flex tw-items-center tw-justify-center",class:{
    active: _vm.props.active,
    completed: _vm.props.completed
  }},[(_vm.props.completed)?_c('ui-material-icon',{staticClass:"tw-text-white fs-10",attrs:{"name":"check"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }